// Intercepts every add-to-cart form; shows an in-flight spinner on the button,
// then AJAX add + "Added!" flash + drawer open. Opt out per-form with data-no-ajax.
// On failure, shows an error toast with the server's reason.
document.addEventListener("submit", async (e) => {
  const form = e.target.closest('form[action$="/cart/add"]');
  if (!form || form.hasAttribute("data-no-ajax")) return;
  e.preventDefault();
  const btn = form.querySelector("[data-atc]");
  const fd = new FormData(form);
  fd.append("sections", "cart-drawer");
  if (btn) window.theme.setLoading(btn, true);
  try {
    const data = await window.theme.postForm(window.routes.cart_add_url + ".js", fd);
    document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { sections: data.sections } }));
    document.dispatchEvent(new CustomEvent("cart:open"));
    if (btn) {
      window.theme.setLoading(btn, false);
      const label = btn.querySelector("[data-atc-label]");
      const original = label ? label.textContent : "";
      btn.classList.add("is-added");
      if (label) label.textContent = btn.dataset.addedLabel || original;
      setTimeout(() => {
        btn.classList.remove("is-added");
        if (label) label.textContent = original;
      }, 1800);
    }
  } catch (err) {
    if (btn) window.theme.setLoading(btn, false);
    window.theme.toast(err && err.message ? err.message : window.theme.strings.atcError, { type: "error" });
  }
});
